$ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var ArchiveDescription = function () {
	this.filterElement = $('#dk-woo-ajax-navigation-series');
	this.first_load = 1;
};

ArchiveDescription.prototype.init = function () {
	var self = this;

	$(document).on('facetwp-loaded', function() {
		self.showBanner();
	});
};

ArchiveDescription.prototype.showBanner = function () {
	var self = this;

	if ( self.filterElement.find( '.facetwp-radio.checked' ).length > 0 ) {
		var filter = self.filterElement.find('.facetwp-radio.checked').attr('data-value');
		var $archiveDescription = $( document.querySelector( '.archive-description-wrap' ) );
		var alreadyExists = $( document.querySelector( '.archive-description.' + filter ) );

		// Remove when removing filter
		$('.remove.series').on( 'click', function() {
			$( document.querySelector( '.archive-description.' + filter ) ).remove();
		});

		// Bail if already exists.
		if ( alreadyExists.length > 0 ) {
			return;
		}
		var data = {
			action: 'big_series_description',
			ajax_nonce: big_ajax.ajax_nonce,
			series_filter: filter,
		};

		$( this ).addClass( 'loading' );

		$.post( big_ajax.url, data, function ( response ) {

			if ( response.success ) {
				$archiveDescription.append( response.data );
			} else {
				console.log( response );
			}
		} ).fail( function ( xhr, textStatus, e ) {
			console.log( xhr.responseText );
		} );
	}
}

module.exports = new ArchiveDescription();
